(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amay-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-amay-slider]').forEach((root)=>{
    const slides=[...root.querySelectorAll('[data-slide]')];
    const dots=[...root.querySelectorAll('[data-dot]')];
    const toggle=root.querySelector('[data-toggle]');
    if(slides.length<2)return;
    let current=0;let timer;let paused=root.dataset.autoplay!=='true'||window.matchMedia('(prefers-reduced-motion: reduce)').matches;let touchStart=0;
    const show=(next)=>{current=(next+slides.length)%slides.length;slides.forEach((slide,index)=>{const active=index===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.querySelectorAll('a,button,input,select,textarea').forEach((item)=>{item.tabIndex=active?0:-1})});dots.forEach((dot,index)=>{const active=index===current;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',String(active))})};
    const stop=()=>{if(timer)window.clearInterval(timer)};
    const start=()=>{stop();if(!paused)timer=window.setInterval(()=>show(current+1),Number(root.dataset.speed)||6000)};
    const setPaused=(value)=>{paused=value;if(toggle){toggle.textContent=paused?'▶':'Ⅱ';toggle.setAttribute('aria-label',paused?root.dataset.playLabel:root.dataset.pauseLabel)}start()};
    root.querySelector('[data-prev]')?.addEventListener('click',()=>{show(current-1);start()});
    root.querySelector('[data-next]')?.addEventListener('click',()=>{show(current+1);start()});
    dots.forEach((dot)=>dot.addEventListener('click',()=>{show(Number(dot.dataset.dot));start()}));
    toggle?.addEventListener('click',()=>setPaused(!paused));
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',(event)=>{if(!root.contains(event.relatedTarget))start()});
    root.addEventListener('touchstart',(event)=>{touchStart=event.changedTouches[0].clientX},{passive:true});root.addEventListener('touchend',(event)=>{const distance=event.changedTouches[0].clientX-touchStart;if(Math.abs(distance)>50){show(current+(distance<0?1:-1));start()}},{passive:true});
    show(0);setPaused(paused);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-showcase]').forEach((section)=>{
    const cards=[...section.querySelectorAll('[data-video-card]')];
    cards.forEach((card)=>{
      const video=card.querySelector('video');
      const button=card.querySelector('[data-video-play]');
      const label=card.querySelector('[data-video-label]');
      if(!video||!button)return;
      const sync=()=>{
        const playing=!video.paused;
        card.classList.toggle('is-playing',playing);
        button.querySelector('span').textContent=playing?'Ⅱ':'▶';
        label.textContent=playing?'PAUSE':'PLAY';
      };
      button.addEventListener('click',()=>{
        if(video.paused){
          cards.forEach((other)=>{const otherVideo=other.querySelector('video');if(otherVideo&&otherVideo!==video)otherVideo.pause();});
          video.play();
        }else{video.pause();}
      });
      video.addEventListener('play',sync);
      video.addEventListener('pause',sync);
      video.addEventListener('ended',sync);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const menuButton=document.querySelector('.menu-button');const menu=document.querySelector('#HeaderNav');if(menuButton&&menu){menuButton.addEventListener('click',()=>{const open=menuButton.getAttribute('aria-expanded')==='true';menuButton.setAttribute('aria-expanded',String(!open));menu.classList.toggle('is-open',!open);document.body.classList.toggle('menu-open',!open)})}const shopMenu=document.querySelector('.header-shop');if(shopMenu){const desktop=window.matchMedia('(min-width:1181px)');let closeTimer;const openShop=()=>{clearTimeout(closeTimer);if(desktop.matches)shopMenu.open=true};const closeShop=()=>{clearTimeout(closeTimer);if(desktop.matches)closeTimer=setTimeout(()=>{if(!shopMenu.matches(':hover')&&!shopMenu.contains(document.activeElement))shopMenu.open=false},450)};shopMenu.addEventListener('mouseenter',openShop);shopMenu.addEventListener('mouseleave',closeShop);shopMenu.addEventListener('focusin',openShop);shopMenu.addEventListener('focusout',closeShop);shopMenu.addEventListener('keydown',(event)=>{if(event.key==='Escape'){clearTimeout(closeTimer);shopMenu.open=false;shopMenu.querySelector('summary')?.focus()}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-checker"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-shipping-checker]').forEach((section)=>{const form=section.querySelector('[data-shipping-form]');const input=form.querySelector('input');const status=form.querySelector('[data-shipping-status]');form.addEventListener('submit',(event)=>{event.preventDefault();const country=input.value.trim();status.textContent=country?form.dataset.success.replace('[country]',country):form.dataset.empty})})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.track-order').forEach((root)=>{
    const tabs=[...root.querySelectorAll('[data-track-tab]')];
    const panels=[...root.querySelectorAll('[data-track-panel]')];
    const activate=(name)=>{
      tabs.forEach((tab)=>{const selected=tab.dataset.trackTab===name;tab.classList.toggle('is-active',selected);tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1});
      panels.forEach((panel)=>{panel.hidden=panel.dataset.trackPanel!==name});
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>activate(tab.dataset.trackTab));
      tab.addEventListener('keydown',(event)=>{if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();const next=event.key==='ArrowRight'?(index+1)%tabs.length:(index-1+tabs.length)%tabs.length;tabs[next].focus();activate(tabs[next].dataset.trackTab)});
    });
    root.querySelector('[data-order-form]')?.addEventListener('submit',(event)=>{event.preventDefault();if(event.currentTarget.reportValidity())window.location.assign(root.dataset.accountUrl)});
    root.querySelector('[data-tracking-form]')?.addEventListener('submit',(event)=>{event.preventDefault();if(!event.currentTarget.reportValidity())return;const number=event.currentTarget.elements.tracking_number.value.trim();if(number)window.location.assign(root.dataset.trackingUrl+encodeURIComponent(number))});
  });

  } catch(e) { console.error(e); }
})();
})();
